import type { ChipProps } from '@montugroup/design-system';

import ProductStrainsMap from '@/constants/products/productStrains';
import type { ProductStrain, ProductStrainKey } from '@montugroup/circuit-shared/types/index';
import { Chip } from '@montugroup/design-system';

interface StrainChipProps {
  strainName: ProductStrain;
  strainKey: ProductStrainKey;
  size?: ChipProps['size'];
}

function StrainChip(props: StrainChipProps) {
  const { strainName, strainKey, size } = props;
  const { icon: Icon, color } = ProductStrainsMap[strainKey];

  return (
    <Chip
      aria-label="Strain"
      size={size}
      variant="outlined"
      label={strainName}
      icon={<Icon color="inherit" sx={{ color }} />}
      sx={{ border: `1px solid ${color}` }}
    />
  );
}

export default StrainChip;
